import { SelectOptionData } from "../../components/Pi/types";
import { VueComponent } from "../../shared/types/VueComponent";
import { PlaceholdersOnes, PlaceholdersStack } from "../Editor/components/Toolbar/types";
import { IMessageSettings } from "./NewMessageEditorWithMedia/Body/logic/types";
import { AvailableButtonsTypes } from "./NewMessageEditorWithMedia/ButtonsConstructor/logic/types";
import { FileType } from "./NewMessageEditorWithMedia/Media/types";
import { CustomMediaTypes } from "./NewMessageEditorWithMedia/types";

export enum MediaEditorMode {
  TelegramBase = 'tgBase',
  TelegramShort = 'tgShort',
  TelegramAll = 'tgAll',
}

export enum MessageEditorWithMediaTab {
  EditorTab,
  TextareaTab,
  SettingsTab,
}

export type MessageEditorComponentSettings = Partial<{
  disabled: boolean,
  editorMode: MediaEditorMode,
  blacklistMediaButtonTypes: Array<FileType>,
  topics: { items: Array<SelectOptionData>, limit: number },
  options: Record<string, any>,
  availableTabs: Array<MessageEditorWithMediaTab>,
  availableButtonsTypes: AvailableButtonsTypes,
  counterMax: number,
  placeholders: PlaceholdersOnes | PlaceholdersStack,

  mediaButtonsMessage: string,
  buttonsInRowMax: number,
  buttonsHelpView: VueComponent | string,
  hasMedia: boolean,
  targetToUpload: Record<string, string | number>,
  emptyKeyboardInfo: VueComponent | string,

  settingsStructure: Partial<IMessageSettings>,
  customMediaTypes: CustomMediaTypes,
  maxMessagesCount: number,
  draggable: boolean,
}>
